// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__Md+mg","logoBlock":"Advt_logoBlock__2DOnH","title":"Advt_title__5JSr0","qrsWrapper":"Advt_qrsWrapper__W4ecM","qrCode":"Advt_qrCode__hWIuL"};